import { fetch, buildUrl } from 'domain/Api';
import { ApiCall } from 'omni-common-ui';

export const FETCH_COVERED_IN_CLASS_CONTENT_REQUEST = 'FETCH_COVERED_IN_CLASS_CONTENT_REQUEST';
export const FETCH_COVERED_IN_CLASS_CONTENT_SUCCESS = 'FETCH_COVERED_IN_CLASS_CONTENT_SUCCESS';
export const FETCH_COVERED_IN_CLASS_CONTENT_FAILURE = 'FETCH_COVERED_IN_CLASS_CONTENT_FAILURE';
export const PUBLISH_CIC_REQUEST = 'PUBLISH_CIC_REQUEST';
export const PUBLISH_CIC_SUCCESS = 'PUBLISH_CIC_SUCCESS';
export const PUBLISH_CIC_FAILURE = 'PUBLISH_CIC_FAILURE';
export const CLEAR_CIC_REQUEST = 'CLEAR_CIC_REQUEST';
export const CLEAR_CIC_SUCCESS = 'CLEAR_CIC_SUCCESS';
export const CLEAR_CIC_FAILURE = 'CLEAR_CIC_FAILURE';
export const CHANGE_COVERED_IN_CLASS_OBJECT = 'CHANGE_COVERED_IN_CLASS_OBJECT';
export const RESET_COVERED_IN_CLASS_OBJECT = 'RESET_COVERED_IN_CLASS_OBJECT';

const buildCoveredInClassUrl = (sessionId) => buildUrl(`/sessions/${sessionId}/covered-in-classes`);

export function fetchCoveredInClassIfNeeded(sessionId) {
  return (dispatch, getState) => {
    const state = getState();
    if (! ApiCall.shouldPerform(state, { method: 'GET', url: buildCoveredInClassUrl(sessionId) })) {
      return false;
    }

    return dispatch(fetchCoveredInClass(sessionId));
  };
}

export function fetchCoveredInClass(sessionId) {
  return (dispatch) => {
    const url = buildCoveredInClassUrl(sessionId);
    const method = 'GET';

    return dispatch(fetchCoveredInClassRequest()).payload
      .then((response) => dispatch(fetchCoveredInClassSuccess(response)))
      .catch((error) => {
        if (error.response.code === 404) {
          return dispatch(fetchCoveredInClassSuccess());
        }

        return dispatch(fetchCoveredInClassFailure(error));
      });

    function fetchCoveredInClassRequest() {
      return ApiCall.createAction({
        type: FETCH_COVERED_IN_CLASS_CONTENT_REQUEST,
        payload: fetch(url),
        url,
        method,
        sessionId,
      });
    }

    function fetchCoveredInClassSuccess(response) {
      return ApiCall.createAction({
        type: FETCH_COVERED_IN_CLASS_CONTENT_SUCCESS,
        payload: response,
        url,
        method,
        sessionId,
      });
    }

    function fetchCoveredInClassFailure(error) {
      return ApiCall.createAction({
        type: FETCH_COVERED_IN_CLASS_CONTENT_FAILURE,
        error,
        url,
        method,
        sessionId,
      });
    }
  };
}

export function publishCoveredInClass(coveredInClassObject, sessionId) {
  return (dispatch) => {
    const url = buildUrl(`/sessions/${sessionId}/cic-publish`);
    const method = 'PUT';

    return dispatch((publishCoveredInClassRequest())).payload
      .then((response) => dispatch(publishCoveredInClassSuccess(response)))
      .catch((error) => dispatch(publishCoveredInClassFailure(error)));

    function publishCoveredInClassRequest() {
      const param = {
        method,
        body: JSON.stringify(coveredInClassObject),
      };
      return ApiCall.createAction({
        type: PUBLISH_CIC_REQUEST,
        payload: fetch(url, param),
        url,
        method,
        disableDefault: true,
      });
    }

    function publishCoveredInClassSuccess(response) {
      return ApiCall.createAction({
        type: PUBLISH_CIC_SUCCESS,
        payload: response,
        url,
        method,
        disableDefault: true,
      });
    }

    function publishCoveredInClassFailure(error) {
      return ApiCall.createAction({
        type: PUBLISH_CIC_FAILURE,
        error,
        url,
        method,
        disableDefault: true,
      });
    }
  };
}

export function clearCoveredInClass(sessionId) {
  return (dispatch) => {
    const url = buildUrl(`/sessions/${sessionId}/cic-clear`);
    const method = 'DELETE';

    return dispatch((clearCoveredInClassRequest())).payload
      .then((response) => dispatch(clearCoveredInClassSuccess(response)))
      .catch((error) => dispatch(clearCoveredInClassFailure(error)));

    function clearCoveredInClassRequest() {
      const param = { method };
      return ApiCall.createAction({
        type: CLEAR_CIC_REQUEST,
        payload: fetch(url, param),
        url,
        method,
        disableDefault: true,
      });
    }

    function clearCoveredInClassSuccess(response) {
      return ApiCall.createAction({
        type: CLEAR_CIC_SUCCESS,
        payload: response,
        url,
        method,
        disableDefault: true,
      });
    }

    function clearCoveredInClassFailure(error) {
      return ApiCall.createAction({
        type: CLEAR_CIC_FAILURE,
        error,
        url,
        method,
        disableDefault: true,
      });
    }
  };
}

export function changeCoveredInClassObject(newObject, sessionId) {
  return {
    type: CHANGE_COVERED_IN_CLASS_OBJECT,
    payload: newObject,
    sessionId,
  };
}

export function resetCoveredInClass(sessionId) {
  return {
    type: RESET_COVERED_IN_CLASS_OBJECT,
    sessionId,
  };
}



// WEBPACK FOOTER //
// ./data/CoveredInClass/actions.js